import React from 'react';
import { styled } from '@mui/material/styles';
import useMyLearning from '../../hooks/useMyLearning';

const TrainingBenefitsAndFeatures = ({ module }) => {
  const { fields } = module;

  const isMyLearning = useMyLearning();

  if (isMyLearning) {
    return;
  }

  return (
    <React.Fragment>
      <Container
        style={{
          backgroundImage: `linear-gradient(rgba(0, 59, 92, 0.25),rgba(0, 59, 92, 0.25)), url(${fields.backgroundImage.url})`,
        }}
      >
        <ImageContainer>
          <FrontImage
            src={fields.featuredImage?.url}
            alt={fields.featuredImage?.text}
          ></FrontImage>
        </ImageContainer>
        <BenefitParent>
          <BenefitTitle>{fields.title}</BenefitTitle>
          <BenefitList>
            {fields.benefitList &&
              fields.benefitList.length > 0 &&
              fields.benefitList.map((benefit, index) => {
                return (
                  <React.Fragment key={index}>
                    <BenefitItem>{benefit.fields.textValue}</BenefitItem>
                    <ListSeparator />
                  </React.Fragment>
                );
              })}
          </BenefitList>
        </BenefitParent>
      </Container>
    </React.Fragment>
  );
};

export default TrainingBenefitsAndFeatures;

const Container = styled('div')({
  position: 'relative',
  height: '540px',
  width: '100%',
  backgroundColor: '#003a5d',
  bottom: '0',
  color: '#fff',
  marginTop: '20px',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  display: 'block',
  '@media only screen and (min-width: 993px)': {
    marginTop: 'inherit',
  },
  '@media only screen and (max-width: 992px)': {
    overflowX: 'hidden',
  },
});

const ImageContainer = styled('div')({
  '@media only screen and (min-width: 768px)': {},
  '@media only screen and (min-width: 993px)': {},
  '@media only screen and (max-width: 992px)': {
    display: 'none',
  },
});

const FrontImage = styled('img')({
  position: 'absolute',
  right: '50%',
  bottom: '0',
  width: 'auto',
  zIndex: '10',
  '@media only screen and (min-width: 993px)': {
    height: '600px',
  },
  '@media only screen and (max-width: 992px)': {
    height: '490px',
  },
});

const BenefitParent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
  alignItems: 'center',
  '@media only screen and (min-width: 993px)': {
    width: '475px',
    height: '90%',
    position: 'absolute',
    left: '52%',
    top: '25px',
  },
  '@media only screen and (max-width: 992px)': {
    width: '350px',
    transform: 'none',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '20px auto 10px auto',
  },
});

const BenefitTitle = styled('div')({
  color: '#fff',
  textTransform: 'uppercase',
  textAlign: 'center',
  '@media screen and (min-width: 993px)': {
    width: '400px',
    fontSize: '2.4rem',
    fontWeight: 'bold',
  },
  '@media screen and (max-width: 992px)': {
    width: '350px',
    fontSize: '2rem',
    fontWeight: 'bold',
    padding: '30px 0 0 0',
  },
});

const BenefitList = styled('ul')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '1rem',
  fontWeight: '300',
  paddingLeft: '0',
  '@media screen and (min-width: 993px)': {
    width: '400px',
  },
  '@media screen and (max-width: 992px)': {
    width: '350px',
    margin: '20px auto 5px auto',
  },
});

const BenefitItem = styled('div')({
  padding: '10px 5px',
  maxWidth: '80%',
  color: '#fff',
  textAlign: 'center',
});

const ListSeparator = styled('hr')({
  margin: '1% 0',
  width: '85%',
  border: '1px dashed #fff',
  '&:last-child': {
    border: '0px',
  },
});
